// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dotted-gradient[data-v-21811b16]{background-image:-webkit-gradient(linear,left top,right top,color-stop(40%,#313131),color-stop(40%,hsla(0,0%,100%,0)));background-image:linear-gradient(90deg,#313131 40%,hsla(0,0%,100%,0) 0);background-position:bottom;background-size:6px 2px;background-repeat:repeat-x;text-transform:inherit;padding-bottom:2px;opacity:.7}", ""]);
// Exports
module.exports = exports;
